// extracted by mini-css-extract-plugin
export default {"frcDealPage":"frcdeal_frcDealPage__flwkM","frame":"frcdeal_frame__tKwcP","loadingOverlay":"frcdeal_loadingOverlay__EtD0W","offlineBox":"frcdeal_offlineBox__3Jx6S"};